import { axiosGet, axiosPost } from "../../../react_axios/Axios";
import { GET_VENDOR_PLAN_DETAIL, GET_VENDOR_PLAN_LIST, getVendorPlanDetailsUrl,UPDATE_VENDOR_PLAN_DETAIL,updateVendorPlanUrl, getVendorPlanListUrl, headers, revokeVendorPlanUrl, REVOKE_VENDOR_PLAN_DETAIL } from '../../../utils/constants'



export const getVendorPlanList_action = (ExhibitionID,WorkOrderNo, ServiceId,StatusID) => async (dispatch) => {

    try {
        const mapdata = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExhibitionID !='' ? ExhibitionID: null,
            AccountID: JSON.parse(sessionStorage.getItem('loginDataSS')).AccountID,
            WorkOrderNo: (WorkOrderNo && WorkOrderNo.trim() !== '') ? WorkOrderNo : '',
            ServiceId: ServiceId !='' ? ServiceId: null,
            StatusID: StatusID !='' ? StatusID: null,
        }
        console.log("data----------", mapdata)
        const res = await axiosGet(getVendorPlanListUrl, mapdata, headers);

        dispatch({
            type: GET_VENDOR_PLAN_LIST,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getVendorPlanDetail_action = (ExhVendorHdrID) => async (dispatch) => {

    try {
        const mapdata = {
            ExhVendorHdrID: ExhVendorHdrID !='' ? ExhVendorHdrID: null
        }
        console.log("data----------", mapdata)
        const res = await axiosGet(getVendorPlanDetailsUrl, mapdata, headers);

        dispatch({
            type: GET_VENDOR_PLAN_DETAIL,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const updateVendorPlan_action = (ExhVendorHdrID, ExhibitionID,IsApproved,IsSaveAsDraft, planDetails,subPointDetails,isAdmin) => async (dispatch) => {
    try {
        const params = {
            ExhVendorHdrID: ExhVendorHdrID != '' ? parseInt(ExhVendorHdrID) : null,
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExhibitionID != '' ? parseInt(ExhibitionID) : null,
            IsApproved: IsApproved != '' ? parseInt(IsApproved) : 0,
            IsSaveAsDraft: IsSaveAsDraft != '' ? parseInt(IsSaveAsDraft) : 0,
            planDetails: planDetails,
            subPointDetails: subPointDetails,
            isAdmin:isAdmin
        }

        const res = await axiosPost(updateVendorPlanUrl, params, headers)

        dispatch({
            type: UPDATE_VENDOR_PLAN_DETAIL,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const revokeVendorPlan_action = (ExhibitionID,WorkOrderID,ServiceID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExhibitionID != '' ? parseInt(ExhibitionID) : null,
            WorkOrderID: WorkOrderID != '' ? parseInt(WorkOrderID) : null,
            ServiceID: ServiceID != '' ? parseInt(ServiceID) : null,
        }

        const res = await axiosPost(revokeVendorPlanUrl, params, headers)

        dispatch({
            type: REVOKE_VENDOR_PLAN_DETAIL,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}